import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import PropTypes from 'prop-types';

const Modal = ({ isOpen, setIsOpen, title, body, primaryButton, secondaryButton, actionAlignment = 'right' }) => (
  <Dialog className="custom-modal" open={isOpen} onClose={() => setIsOpen(false)}>
    <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
    <DialogContent className="dialog-content">{body}</DialogContent>
    <DialogActions className="dialog-actions" style={{ justifyContent: actionAlignment }}>
      {primaryButton && <primaryButton.type {...primaryButton.props} />}
      {secondaryButton && <secondaryButton.type {...secondaryButton.props} />}
    </DialogActions>
  </Dialog>
);

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  primaryButton: PropTypes.element,
  secondaryButton: PropTypes.element,
  actionAlignment: PropTypes.oneOf(['left', 'center', 'right']),
};

export default Modal;
